const DESKTOP_MEDIA_QUERY = "(min-width: 550px)";

class contentBildVideo extends HTMLElement {

    constructor() {
        super();
        this.playVideo = true;
        this.isVisible = false;
        this.desktopMediaQuery = null;
        this.videoObserver = null;
        this.handleViewportChange = this.handleViewportChange.bind(this);
    }

    disconnectedCallback() {
        this.desktopMediaQuery?.removeEventListener("change", this.handleViewportChange);
        this.videoObserver?.disconnect();
    }

    connectedCallback() {
        this.buttonPlay = this.querySelector(".button-play");
        this.buttonPlayIcon = this.querySelector(".icon-play");
        this.buttonPlayText = this.querySelector(".button-play--text");
        this.videos = this.querySelectorAll(".videoplayer");
        this.desktopVideos = this.querySelectorAll(".videoplayer.video-desktop");
        this.mobileVideos = this.querySelectorAll(".videoplayer.video-mobile");

        this.desktopMediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
        this.desktopMediaQuery.addEventListener("change", this.handleViewportChange);

        this.initPlayerButton();
        this.initVideoVisibilityObserver();
    }

    // Player-Button
    initPlayerButton() {
        if (!this.buttonPlay) {
            return; // Button existiert nicht, z.B. wenn kein Video vorhanden
        }

        this.buttonPlay.addEventListener("click", () => {
            if (this.playVideo) {
                this.stopVideo();
            } else {
                this.startVideo();
            }
        });
    }

    // Video erst abspielen, wenn es im sichtbaren Bereich ist
    initVideoVisibilityObserver() {
        if (!this.videos.length) {
            return;
        }
        this.videoObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    return;
                }
                this.isVisible = true;
                if (this.playVideo) {
                    this.playActiveVideos();
                }
                this.videoObserver.disconnect();
            });
        }, { threshold: 0.1 });
        this.videos.forEach(video => this.videoObserver.observe(video));
    }

    // Nur die zum aktuellen Viewport passenden Videos
    activeVideos() {
        return this.desktopMediaQuery.matches ? this.desktopVideos : this.mobileVideos;
    }

    inactiveVideos() {
        return this.desktopMediaQuery.matches ? this.mobileVideos : this.desktopVideos;
    }

    // Button-Icon und -Text an den Wiedergabestatus anpassen (Button fehlt bei Deko-Animation)
    updateButton(playing) {
        if (!this.buttonPlayIcon || !this.buttonPlayText) {
            return;
        }
        this.buttonPlayIcon.classList.toggle("element-icon-pause", playing);
        this.buttonPlayIcon.classList.toggle("element-icon-play", !playing);
        this.buttonPlayText.innerText = playing
            ? "Video gestartet. Klicken, um Video zu stoppen"
            : "Video gestoppt. Klicken, um Video zu starten";
    }

    // Video stoppen
    stopVideo() {
        this.updateButton(false);
        this.playVideo = false;
        this.videos.forEach(video => {
            video.pause();
        });
    }

    // Video starten
    startVideo() {
        this.updateButton(true);
        this.playVideo = true;
        if (this.isVisible) {
            this.playActiveVideos();
        }
    }

    // Nur das zum Viewport passende Video laden und abspielen
    playActiveVideos() {
        this.inactiveVideos().forEach(video => video.pause());
        this.activeVideos().forEach(video => video.play());
    }

    // Viewport-Wechsel: nur fortsetzen, wenn nicht manuell gestoppt
    handleViewportChange() {
        if (this.playVideo) {
            this.startVideo();
        }
    }

}

if (!customElements.get("content-bild-video")) {
    customElements.define("content-bild-video", contentBildVideo);
}
